export {default as ConfigMasterTemplate} from './config-master-template'